import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DivisionDataProvider } from "../../data-provider/division.dp";

let DivisionListComponent = {
    selector: "vcDivisionList",
    templateUrl: "/angular/components/division/division-list.component.html",
    bindings: {
        searchString: "=",
    },
    controller: class DivisionListController {
        // * bindings for typescript compiler *
        public searchString: string;
        // ************************************

        private readonly $scope: any;
        private readonly $timeout: any;
        public readonly __env: any;

        private readonly dataProvider: DivisionDataProvider;
        private readonly campaignDataProvider: CampaignDataProvider;

        private gmapApi: any;
        private gmapIsReady: any;
        private $window: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private campaignsTimeoutCode: any;
        private timeoutCode: any;
        private savingCampaigns = false;
        private saving = false;
        private delay = 1000; //amount of time, in ms, to wait before sending updateOrder request

        public activeOrganisation: Organisation;
        public loading = true;
        public hideShadow: boolean;
        public divisions: Array<Division>;
        public campaignLimit = 10;

        constructor(
            $scope: any,
            $timeout: any,
            $window: any,
            __env: any,
            uiGmapGoogleMapApi: any,
            uiGmapIsReady: any,
            DivisionDataProvider: DivisionDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$window = $window;
            this.__env = __env;
            this.dataProvider = DivisionDataProvider;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.campaignDataProvider = CampaignDataProvider;
            this.gmapApi = uiGmapGoogleMapApi;
            this.gmapIsReady = uiGmapIsReady;

            this.dataProvider
                .getAllDivisions()
                .then((divisions: Array<Division>) => {
                    this.divisions = divisions;
                    this.loading = false;
                });

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                });
        }

        editDivision(division: Division, $event: any): void {
            if (!division.restricted) {
                this.dialog.show({
                    component: "vc-division-create-dialog",
                    targetEvent: $event,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    multiple: false,
                    locals: {
                        division: division,
                    },
                });
            }
        }

        changeCampaign(campaign: Campaign): void {
            this.loading = true;
            this.campaignDataProvider.changeLiveCampaign(campaign).then(
                () => {
                    this.$window.location = "/";
                },
                (error: any) => {
                    this.loading = false;
                    this.toast.error(error);
                }
            );
        }

        setHideShadow(bool: boolean): void {
            this.hideShadow = bool;
        }

        saveCampaigns(campaigns: Array<Campaign>, division: Division): void {
            this.$timeout.cancel(this.campaignsTimeoutCode); //does nothing, if timeout already done
            this.campaignsTimeoutCode = this.$timeout(() => {
                if (!this.savingCampaigns) {
                    this.savingCampaigns = true;

                    const campaignIDs = campaigns.map((item: Campaign) => {
                        return item["campaignid"];
                    });
                    const data = {
                        ids: campaignIDs,
                        divisionid: division.id,
                        oid: this.activeOrganisation.oid,
                    };
                    this.dataProvider.updateCampaignsOrder(data).then(() => {
                        this.savingCampaigns = false;
                    });
                }
            }, this.delay);
        }

        saveDivisions(): void {
            this.$timeout.cancel(this.timeoutCode); //does nothing, if timeout already done
            this.timeoutCode = this.$timeout(() => {
                if (!this.saving) {
                    this.saving = true;
                    const divisions = this.dataProvider.divisions;
                    let data = divisions.map((item: object) => {
                        return item["id"];
                    });
                    data = { ids: data };
                    this.dataProvider.updateOrder(data).then(() => {
                        this.saving = false;
                    });
                }
            }, this.delay);
        }

        campaignsLimit(division: Division): number {
            if (!division.expanded) {
                return this.campaignLimit;
            }

            return 200;
        }

    },
};

angular
    .module("division")
    .component(DivisionListComponent.selector, DivisionListComponent);
